var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { executeRequest } from '~utils/executeRequest';
import { filterParams } from '~utils/filterParams';
import { name } from './constants';
var baseGlobalRankingURL = 'ranking-service/v1/global-ranking';
var normalizeError = function (e) {
    if (e === null || e === undefined) {
        return { message: 'Unknown error' };
    }
    if (typeof e === 'string') {
        return { message: e };
    }
    if (typeof e === 'object') {
        var obj = e;
        var message = obj.message || obj.error;
        var code = obj.code;
        var status_1 = obj.status;
        if (typeof message === 'string' && message.trim().length > 0) {
            return { message: message, code: code, status: status_1 };
        }
    }
    return { message: 'Unexpected error' };
};
var buildRankingQueryParams = function (args) {
    var date = args.date, gameUid = args.gameUid, accumulation = args.accumulation, rest = __rest(args, ["date", "gameUid", "accumulation"]);
    var isGameUid = Boolean(gameUid && !date && !accumulation);
    return filterParams(__assign(__assign(__assign(__assign({}, rest), (isGameUid ? { gameUid: gameUid } : {})), (accumulation ? { accumulation: accumulation } : {})), (date ? { date: date } : {})));
};
var performRankingRequest = function (baseURL, params) { return __awaiter(void 0, void 0, void 0, function () {
    var errorResult, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                errorResult = null;
                return [4 /*yield*/, executeRequest({
                        url: "".concat(baseURL, "/v2/ranking"),
                        options: { method: 'GET' },
                        params: __assign({}, params),
                        setError: function (err) {
                            errorResult = err;
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response ||
                    typeof response !== 'object' ||
                    !('data' in response) ||
                    'error' in response) {
                    throw normalizeError(errorResult);
                }
                return [2 /*return*/, response.data];
        }
    });
}); };
var performGlobalRankingRequest = function (endpoint, params) { return __awaiter(void 0, void 0, void 0, function () {
    var errorResult, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                errorResult = null;
                return [4 /*yield*/, executeRequest({
                        url: "".concat(baseGlobalRankingURL, "/").concat(endpoint),
                        options: { method: 'GET' },
                        params: params,
                        setError: function (err) {
                            errorResult = err;
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response ||
                    typeof response !== 'object' ||
                    !('data' in response) ||
                    'error' in response) {
                    throw normalizeError(errorResult);
                }
                return [2 /*return*/, response.data];
        }
    });
}); };
export var getDailyRanking = createAsyncThunk("".concat(name, "/getDailyRanking"), function (params, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var baseURL, rest, queryParams, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    baseURL = params.baseURL, rest = __rest(params, ["baseURL"]);
                    queryParams = buildRankingQueryParams(rest);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, performRankingRequest(baseURL, queryParams)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    e_1 = _b.sent();
                    return [2 /*return*/, rejectWithValue(normalizeError(e_1))];
                case 4: return [2 /*return*/];
            }
        });
    });
});
export var getWeeklyRanking = createAsyncThunk("".concat(name, "/getWeeklyRanking"), function (params, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var baseURL, rest, queryParams, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    baseURL = params.baseURL, rest = __rest(params, ["baseURL"]);
                    queryParams = buildRankingQueryParams(rest);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, performRankingRequest(baseURL, queryParams)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    e_2 = _b.sent();
                    return [2 /*return*/, rejectWithValue(normalizeError(e_2))];
                case 4: return [2 /*return*/];
            }
        });
    });
});
export var getRankingListAsync = createAsyncThunk("".concat(name, "/getRankingListAsync"), function (params, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var baseURL, rest, queryParams, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    baseURL = params.baseURL, rest = __rest(params, ["baseURL"]);
                    queryParams = buildRankingQueryParams(rest);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, performRankingRequest(baseURL, queryParams)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    e_3 = _b.sent();
                    return [2 /*return*/, rejectWithValue(normalizeError(e_3))];
                case 4: return [2 /*return*/];
            }
        });
    });
});
export var getGlobalRankingMaster = createAsyncThunk("".concat(name, "/getGlobalRankingMaster"), function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, performGlobalRankingRequest('master')];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    e_4 = _b.sent();
                    return [2 /*return*/, rejectWithValue(normalizeError(e_4))];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var getGlobalRankingDetails = createAsyncThunk("".concat(name, "/getGlobalRankingDetails"), function (params, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var filteredParams, e_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    filteredParams = filterParams(params);
                    return [4 /*yield*/, performGlobalRankingRequest('details', filteredParams)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    e_5 = _b.sent();
                    return [2 /*return*/, rejectWithValue(normalizeError(e_5))];
                case 3: return [2 /*return*/];
            }
        });
    });
});
